/** @jsxImportSource @emotion/react */
import { Column } from '@ssmm/ui';
import { cases } from 'components/landing/settings';
import { arrowRight } from 'components/landing/ui/icons';
import { useState } from 'react';

import { Button, colors, Modal } from '../../../ui';
import Case from './case';

const CaseModal = ({ onClose, selectedCase: selectedCaseProp }) => {
  const [selectedCase, setSelectedCase] = useState(selectedCaseProp);

  return (
    <Modal
      title="Опыт наших пользователей:"
      onClose={onClose}
      getContainer={() => document.getElementById('root')}
      width={798}
    >
      <Column
        css={{
          padding: `30px 0 35px 30px`,
        }}
        shrink={1}
        overflow="hidden"
      >
        <Column
          css={{
            paddingRight: 30,
          }}
          scroll
        >
          {selectedCase === 'menu' ? (
            <div css={{ flexDirection: 'column', width: '100%' }}>
              <div
                css={{
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                  button: {
                    width: '100%',
                    marginBottom: 30,
                    height: 80,
                    textTransform: 'uppercase',
                  },
                  paddingBottom: 10,
                  borderBottom: `1px solid ${colors.grayLight}`,
                  '@media (min-width:510px)': {
                    flexDirection: 'row',
                    button: {
                      width: 'unset',
                      flexBasis: '40%',
                      flexGrow: 1,
                    },
                    'button:nth-of-type(odd)': { marginRight: 30 },
                  },
                }}
              >
                {Object.keys(cases).map(k => (
                  <Button onClick={() => setSelectedCase(k)} key={k}>
                    {cases[k].title}
                  </Button>
                ))}
              </div>
              <div css={{ paddingTop: 40, justifyContent: 'flex-end' }}>
                <Button type="blue" icon={arrowRight}>
                  Зарегистрироваться
                </Button>
              </div>
            </div>
          ) : (
            <Case target={cases[selectedCase]} onBackClick={() => setSelectedCase('menu')} />
          )}
        </Column>
      </Column>
    </Modal>
  );
};

export default CaseModal;
